export const MODULE_NAME = 'ACCOUNT_SETTINGS_LOGOUT_MODULE_NAME';

export const ACTION_TYPE = {
  REQUEST_PENDING: `${MODULE_NAME}.REQUEST_PENDING`,
};
